import { makeAutoObservable } from "mobx";

import { ajaxController } from "./AjaxController";
import { CourierShipmentResponseModel } from "../DTOs/Delivery/CourierShipmentResponseModel";
import { CourierShipmentQuoteRequest } from "../DTOs/Delivery/CourierShipmentQuoteRequest";

export class StockistCourierShipmentAjaxController {
  private _ajaxController = ajaxController;
  private _publisherCourierShipmentEndpoint = "stockistCourierShipment";

  getQuotes(data: CourierShipmentQuoteRequest) {
    return this._ajaxController.postNoCast<CourierShipmentQuoteRequest, CourierShipmentResponseModel>(
      `${this._publisherCourierShipmentEndpoint}/quotes`,
      data
    )
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const stockistCourierShipmentAjaxController = new StockistCourierShipmentAjaxController();